import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { rel } from '@ifeng-fe/container_channel/common/client/utils/rel';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Nav extends React.PureComponent {
    static propTypes = { content: PropTypes.array };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        const navigation = content.map((item, index) => (
            <li key={index} className={index === 0 ? styles.pa : ''}>
                <a target="_blank" rel={rel} title={item.title} href={item.url}>
                    {item.title}
                </a>
            </li>
        ));

        return (
            <div className={styles.col_box}>
                <div className={styles.col_navlist}>
                    <ul className="clearfix">
                        {navigation}
                        <li style={{ display: 'none' }}>
                            <a href="https://biz.ifeng.com/" target="_blank" rel={rel} title="品牌主场">
                                品牌主场
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Nav);
